import React, { Component } from 'react';

import Toggle from 'react-bootstrap-toggle';

import translator from '../../../components/localization/translator';
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
export default class ToggleWithLabel extends Component {

	renderLabel() {
		let labelStyle = this.props.labelStyle? this.props.labelStyle : 'label-width';
		if (!this.props.label) {
			return null;
		}
		return (
			<label htmlFor={this.props.htmlFor} className={labelStyle}>
				{translator.translate(this.props.label)}
			</label>
		);
	}

	render() {
		let additionalStyle = this.props.additionalStyle || '';
		if (this.props.style) {
			additionalStyle = `${additionalStyle} padding`;
		}
		return(
			<div className={`display-flex ${additionalStyle}`}>
				{this.renderLabel()}
				<Toggle
					disabled={this.props.disabled}
					id={'toggle'}
					onClick={this.props.onToggle}
					on={<b>{translator.translate(this.props.onText)}</b>}
					off={<b>{translator.translate(this.props.offText)}</b>}
					size="sm"
					onstyle={this.props.onClassName || 'primary'}
					offstyle={this.props.offClassName || 'default'}
					active={this.props.active} />
			</div>
		);
	}
}